import { postRequest } from './HttpClient';
import {
  VarnakramaRequest,
  VarnakramaResponse,
  VarnasaaraData,
  VarnasaaraResponse,
  VedaType,
  OutputType
} from '../types';

export const callVarnakramaAPI = async (
  word: string,
  veda: VedaType,
  outputType: OutputType
): Promise<VarnakramaResponse> => {
  const requestBody: VarnakramaRequest = {
    word,
    veda,
    compute_shuddha: outputType === 'shuddha' || outputType === 'sarve',
    compute_svara: outputType === 'svara' || outputType === 'sarve',
    compute_maatra: outputType === 'maatra' || outputType === 'sarve',
    compute_anga: outputType === 'anga' || outputType === 'sarve',
    compute_varnasaara: outputType === 'varnasaara' || outputType === 'sarve',
  };

  try {
    console.log('Trying V2 API endpoint...');
    const response = await postRequest<VarnakramaResponse>('v2/varnakrama', requestBody);
    console.log('V2 API successful');
    return response;
  } catch (error) {
    console.warn('V2 API failed, falling back to V1:', error);
    try {
      const response = await postRequest<VarnakramaResponse>('varnakrama', requestBody);
      console.log('V1 API fallback successful');
      return response;
    } catch (v1Error) {
      console.error('Both V2 and V1 APIs failed:', v1Error);
      throw v1Error;
    }
  }
};

export const callVarnasaaraAPI = async (
  word: string,
  veda: VedaType
): Promise<VarnasaaraData> => {
  try {
    const requestBody = {
      word,
      veda,
      output_format: 'json' as const,
    };
    console.log('Calling varnasaara JSON API...');
    const response = await postRequest<VarnasaaraResponse>('v2/varnasaara/json', requestBody);
    console.log('Got JSON format from API!');
    return response.varnasaara;
  } catch (error) {
    console.error('Varnasaara JSON API failed:', error);
    throw error;
  }
};
